import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'avatarInitial',
  standalone: true
})
export class AvatarInitialPipe implements PipeTransform {
    
  transform(name: string | null | undefined): string {
    if (!name) return '';
    const nameParts = name.split(' ').filter(part => part.length > 0);
    
    if (nameParts.length === 0) return '';
    if (nameParts.length === 1) {
      return nameParts[0].substring(0, 2).toUpperCase();
    }
    return (nameParts[0][0] + nameParts[nameParts.length - 1][0]).toUpperCase();
  }
} 